module.exports = __webpack_public_path__ + "static/media/camera6.f1decc45.jpg";